// extracted by mini-css-extract-plugin
export default {"root":"_3zAes","cover":"b_fVg","middle":"_2B3kq","mature-block":"_1BNfI","matureBlock":"_1BNfI","underlay":"w8jq4"};